class BadRequestError extends Error {
    constructor(cause?: Error) {
        super("La petición es errónea o mal formada", {
            cause,
        });
    }
}

export { BadRequestError };
